import UploadProfile from 'views/register/uploadProfile/UploadProfile.container';

export default UploadProfile;